



























import {Component} from 'vue-property-decorator';
import Slide from '@/presentation/slides/Slide';
import config from '@/config';
import { Vue } from 'vue-property-decorator';

@Component({components: {}})
export default class Imagex extends Slide {
  get background() {
    switch (this.section.SubType) {
      case 'yearendSigning':
      case 'completionFeedback':
      case 'completionNextmeeting':
        return true;
    }
    return false;
  }

  get id() {
    switch (this.section.SubType) {
      case 'yearendSigning':
        return 'signing';
      case 'completionFeedback':
        return 'feedback';
      case 'completionNextmeeting':
        return 'calendar';
    }
    return this.section.SubType;
  }

  get src() {
    let langSuffix = '';
    if (Vue.prototype.$l === 'en') {
      langSuffix = '_EN';
    }

    switch (this.section.SubType) {
      case 'gtAdvisoryYourjourney':
        return `/static/gt/image/din_resa${langSuffix}.png`;
      case 'gtAdvisoryHouse':
        return `/static/gt/image/huset${langSuffix}.png`;
      case 'cashflowExample':
        return this.imagePath + `cashflow_example${langSuffix}.png`;
      case 'custom':
        if (this.isPrint) {
          return `/admin/blob/${this.section.Src}`;
        } else {
          return `/api/user/blob/${this.section.Src}`;
        }
    }
    return '';
  }

  get title() {
    if (this.section.Title) {
      return this.section.Title;
    }
    switch (this.section.SubType) {
      case 'yearendSigning':
        return 'Signering';
      case 'completionFeedback':
        return 'Feedback';
      case 'completionNextmeeting':
        return 'Nästa möte';
      case 'gtAdvisoryYourjourney':
        return 'Din resa';
      case 'gtAdvisoryHouse':
        return 'Kundmöte';
      case 'cashflowExample':
        return 'Exempel';
    }
    return '';
  }

  get isPrint(): boolean {
    if (
        !this.$router ||
        !this.$router.currentRoute ||
        !this.$router.currentRoute.name
    ) {
      return false;
    }
    return this.$router.currentRoute.name.endsWith('print');
  }

  get imagePath() {
    switch (config.brand) {
      case 'BK':
        return '/static/bk/image/';
      case 'GT':
        return '/static/gt/image/';
      default:
        return '';
    }
  }
}
